var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "message-search" } }, [
    _c("div", { staticClass: "search-bar" }, [
      _c("div", { staticClass: "material-icons" }, [_vm._v("search")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query",
          },
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.query },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.query = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "results" },
      [
        _vm.query.length <= 0 && !_vm.results.length
          ? _c("div", { staticClass: "not-found" }, [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v("chat_bubble"),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "Aramak istediğiniz mesaj içeriğini veya gönderen kişinin adını belirtiniz."
                ),
              ]),
            ])
          : _vm.query.length > 0 && !_vm.results.length
          ? _c("div", { staticClass: "not-found" }, [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v("comments_disabled"),
              ]),
              _vm._v(" "),
              _c("div", [_vm._v("Yakın zamanlarda bir sonuç bulunmadı.")]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.results, function (result) {
          return _c(
            "div",
            {
              staticClass: "result-item",
              on: {
                click: function ($event) {
                  return _vm.messageSelected(result)
                },
              },
            },
            [
              _c("div", {
                staticClass: "message",
                domProps: { innerHTML: _vm._s(result.description) },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "footer" }, [
                _c("div", { staticClass: "author" }, [
                  _vm._v(
                    _vm._s(
                      result.messageType == "visitor"
                        ? "Visitor"
                        : result.user.name
                    ) + " -"
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "date" }, [
                  _vm._v(_vm._s(_vm.$moment(result.date).format("HH:mm"))),
                ]),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        (_vm.query.length > 0 && !_vm.results.length) || _vm.results.length > 0
          ? _c(
              "div",
              { staticClass: "load-more", on: { click: _vm.loadMore } },
              [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v("search"),
                ]),
                _vm._v("\n            Daha fazla göz at\n        "),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }